import _isEmpty from 'lodash/isEmpty';
import { ErrorToast, generateVideoUrl } from '../utils/Utils';

export const checkType = (variable) => {
  if (typeof variable === 'string') {
    return false;
  }
  return true;
};

export const getStepTwoDataRule = (id, mandatoryRuleCoditions) => {
  const formattedData = {
    journeyId: id,
    mandatoryRuleCoditions,
  };

  return JSON.stringify(formattedData);
};

export const getStepTwoDataDept = (id, data) => {
  const formattedData = {
    journeyId: id,
    departmentRoles: data?.departmentRoleIds,
  };

  return JSON.stringify(formattedData);
};

export const getStepOneData = (data) => {
  const datas = new FormData();
  datas.append('title', data.journeyTitle || '');
  datas.append('goal', data.journeyGoal || '');
  datas.append('description', data.courseOverview || '');
  // eslint-disable-next-line no-nested-ternary
  datas.append('skillLevel', data.skillLevel === 0 ? 'novice' : data.skillLevel === 1 ? 'intermediate' : 'expert');

  datas.append('courseCode', data.courseCode || '');

  datas.append('isOEM', data.isOEM === '1');
  if (data.isOEM === '1' && data.dueDate) {
    datas.append('dueDate', data.dueDate);
  }
  if (data.publishDate) {
    datas.append('publishDate', data.publishDate);
  }
  if (data.previewLink) {
    const hasAvPreview = data.avPreview && !_isEmpty(data.avPreview);
    const previewLinkValue =
      hasAvPreview && data.avPreview?.url === data.previewLink ? generateVideoUrl(data.avPreview) : data.previewLink;
    datas.append('previewVideoLink', previewLinkValue);
  } else {
    datas.append('previewVideoLink', '');
  }
  if (data.thumbnail && checkType(data.thumbnail)) {
    datas.append('thumbnail', data.thumbnail);
  }
  if (data.certificateBg) {
    datas.append('certificate', data.certificateBg);
  }
  data.collections
    ?.map((item) => item.value)
    .filter((val) => val && val !== '*')
    .forEach((val) => {
      datas.append('collectionIds', String(val));
    });
  data.tags?.forEach((val) => {
    datas.append('tagIds', String(val.id));
  });

  return datas;
};

export const updateArrayState = (prevData, name, value, checked) => {
  const val = parseInt(value, 10);
  const updatedArray = checked ? [...prevData[name], val] : prevData[name]?.filter((item) => item !== val);
  return { ...prevData, [name]: updatedArray };
};

export const updateIsSelectedTrue = (data) =>
  data.map((category) => ({
    ...category,
    isSelected: true,
    roles:
      category.roles?.map((role) => ({
        ...role,
        isSelected: true,
      })) || [],
  }));

export const validateStepOneData = (data, add) => {
  if (!data?.journeyTitle?.trim()) {
    ErrorToast('Journey title is required');
    return false;
  }

  if (!data?.journeyGoal?.trim()) {
    ErrorToast('Journey goal is required');
    return false;
  }

  if (data?.courseCode?.trim().length > 15) {
    ErrorToast('Course code cannot exceed 15 characters.');
    return false;
  }

  if (!data?.courseOverview?.trim()) {
    ErrorToast('Course overview is required');
    return false;
  }

  if (data.isOEM === '1' && !data.dueDate) {
    ErrorToast('Due date is required');
    return false;
  }

  if (data.publishDate && Number.isNaN(Date.parse(data.publishDate))) {
    ErrorToast('Publish date is not valid');
    return false;
  }

  if (!data.thumbnail && add) {
    ErrorToast('Thumbnail is required');
    return false;
  }

  return true;
};
